import { WidgetType } from '../../core/template-definition.model';
import { Scorecard } from '../../scorecard-next.model';

export function getYourTeamEnabled(selectedScorecard: Scorecard): boolean {
    let result = false;
    if (selectedScorecard?.data?.widgetTemplateConfig?.widgets != null) {
        result = selectedScorecard.data.widgetTemplateConfig.widgets.some(
            (e) => {
                return e.widgetType === WidgetType.YOUR_TEAM && e.enabled;
            },
        );
    }
    return result;
}
